import { WatchlistWidget } from "@/components/ux";
import { MyOpenTasksWidget } from "@/pages/tasks/components/MyOpenTasksWidget";
import { UpcomingAppointmentsWidget } from "@/pages/calendar/components/UpcomingAppointmentsWidget";
import { MyRecentCommunicationsWidget } from "@/pages/communications/components/MyRecentCommunicationsWidget";
import { NeedsMyAttentionPanel } from "./NeedsMyAttentionPanel";
import { RecentlyViewedPanel } from "./RecentlyViewedPanel";
import { WidgetBoundary } from "./WidgetFrame";

/**
 * The "what needs me right now" column rendered on EVERY role's dashboard,
 * regardless of recipe. All five widgets are pre-existing live surfaces —
 * this is assembly, not invention — and each is isolated in its own
 * boundary so one failing feed never takes down the band.
 */
export function PersonalBand() {
  return (
    <div className="flex flex-col gap-space-4">
      <WidgetBoundary title="My open tasks">
        <MyOpenTasksWidget />
      </WidgetBoundary>
      <WidgetBoundary title="Upcoming">
        <UpcomingAppointmentsWidget />
      </WidgetBoundary>
      <WidgetBoundary title="Needs my attention">
        <NeedsMyAttentionPanel />
      </WidgetBoundary>
      <WidgetBoundary title="My watchlist">
        <WatchlistWidget />
      </WidgetBoundary>
      <WidgetBoundary title="Recently viewed">
        <RecentlyViewedPanel />
      </WidgetBoundary>
      <WidgetBoundary title="My recent communications">
        <MyRecentCommunicationsWidget />
      </WidgetBoundary>
    </div>
  );
}
